var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":_vm.placeName}},[(_vm.logo)?_c('img',{staticStyle:{"width":"18px","height":"18px","vertical-align":"middle"},attrs:{"src":_vm.logo}}):_c('md-icon',{staticStyle:{"font-size":"18px !important","vertical-align":"middle"}},[_vm._v("warehouse")]),_vm._v(" "+_vm._s(_vm.displayName || _vm.placeName)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }